// Crop names copied from the BeeKind mobile app's bundled crop list
// (beekind-fieldview/src/assets/Crops/crops.json), so the web Key Crop
// dropdown offers the same crops the field agents see on their phones.
export const POLLINATION_CROPS = [
  "Acacia",
  "Alangium salvifolium",
  "Almond",
  "Apple",
  "Apricot",
  "Areca",
  "Arhar (Pigeon pea)",
  "Avocado",
  "Babool",
  "Banana",
  "Ber (Sidr)",
  "Blackberry",
  "Blueberry",
  "Bombax/Silk cotton tree",
  "Cabbage",
  "Carom",
  "Carrot",
  "Cashew",
  "Cassia",
  "Castor",
  "Cauliflower",
  "Cherry",
  "Chili",
  "Coconut",
  "Coffee",
  "Coriander",
  "Cotton",
  "Cranberry",
  "Crepe-myrtle",
  "Cucumber",
  "Currants",
  "Curry tree",
  "Dahlia",
  "Dill",
  "Eucalyptus",
  "Fennel",
  "Fenugreek",
  "Gourds",
  "Gram (Chick pea)",
  "Grapefruit",
  "Groundnut",
  "Guava",
  "Jamun",
  "Kiwi",
  "Lemon",
  "Linseed",
  "Litchi",
  "Lucerne (Alfalfa)",
  "Mahua",
  "Maize",
  "Mango",
  "Melons",
  "Mimosa",
  "Moringa",
  "Mustard",
  "Neem",
  "Niger",
  "Oil palm",
  "Onion",
  "Orange",
  "Other cucurbits",
  "Palash",
  "Peach",
  "Pear",
  "Pearl Millet",
  "Persimmon",
  "Pineapple",
  "Plum",
  "Pomegranate",
  "Pongamia",
  "Pumpkin",
  "Radish",
  "Rape seed/Canola",
  "Raspberry",
  "Rice",
  "Rosemary",
  "Rubber",
  "Safflower",
  "Sage",
  "Salvadora",
  "Sesame",
  "Sheesham",
  "Soapnut",
  "Sorghum",
  "Soyabean",
  "Strawberry",
  "Sunflower",
  "Tamarind",
  "Thyme",
  "Trumpet vine",
  "Tuberose",
  "Turnip",
  "Wild Tulsi",
  "Wild date palm"
];
